import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();

  // ✅ az-AZ, en-US kimi gəlirsə -> az/en/ru edirik
  const currentLang = (i18n.resolvedLanguage || i18n.language || "az").split("-")[0];

  const changeLang = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng); // ✅ yadda saxla
  };

  const close = () => setOpen(false);

  return (
    <header className="navHeader">
      <div className="container navContainer">
        <Link to="/" onClick={close} className="navLogo">
          <img style={{ borderRadius: "11px" }} src="/images/scorivaLogo.jpg" alt="Scoriva Logo" />
        </Link>

        <button onClick={() => setOpen((p) => !p)} className="navBurger" aria-label="Menu">
          <span></span><span></span><span></span>
        </button>

        <nav className={`navLinks ${open ? "open" : ""}`}>
          <NavLink to="/" end onClick={close} className="navA">{t("home")}</NavLink>
          <NavLink to="/haqqimizda" onClick={close} className="navA">{t("about")}</NavLink>
          <NavLink to="/mehsullar" onClick={close} className="navA">{t("products")}</NavLink>
          <NavLink to="/tedqiqat" onClick={close} className="navA">{t("research")}</NavLink>
          <NavLink to="/blog" onClick={close} className="navA">{t("blog")}</NavLink>
          <NavLink to="/elaqe" onClick={close} className="navA">{t("contact")}</NavLink>

          <select value={currentLang} onChange={changeLang} className="langSelect">
            <option value="az">AZ</option>
            <option value="en">EN</option>
            <option value="ru">RU</option>
          </select>
        </nav>
      </div>
    </header>
  );
}
